// @flow

import React from 'react';
import { Helmet } from 'react-helmet';

import LocaleCode from '../LocaleCode';

const HelmetWrapper = () => (
  <LocaleCode>
    {localeCode => (
      <Helmet
        titleTemplate={process.env.REACT_APP_TITLE_TEMPLATE || ''}
        defaultTitle={process.env.REACT_APP_DEFAULT_TITLE || ''}
      >
        <html lang={localeCode} />
      </Helmet>
    )}
  </LocaleCode>
);

export default HelmetWrapper;



// WEBPACK FOOTER //
// ./src/providers/Helmet/index.js